import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5575a6e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-game-root" }
const _hoisted_2 = { class: "game-header" }
const _hoisted_3 = { class: "table-name" }
const _hoisted_4 = { class: "table-round" }
const _hoisted_5 = { class: "user-name" }
const _hoisted_6 = { class: "user-balance" }
const _hoisted_7 = { class: "value-btns-h" }
const _hoisted_8 = {
  key: 3,
  class: "user-control-btns"
}
const _hoisted_9 = { class: "value-btns" }
const _hoisted_10 = { class: "value-btns" }
const _hoisted_11 = { class: "value-btns" }
const _hoisted_12 = { class: "value-btns" }
const _hoisted_13 = { class: "value-btns" }
const _hoisted_14 = { class: "value-btns" }
const _hoisted_15 = {
  key: 4,
  class: "btn-s"
}
const _hoisted_16 = { class: "value-btns" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fill" }, null, -1))
const _hoisted_18 = {
  key: 5,
  class: "display-mode-wrap"
}
const _hoisted_19 = { class: "label" }
const _hoisted_20 = { class: "m-game-header" }
const _hoisted_21 = { class: "info user-name" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "info user-coin" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-h-fill" }, null, -1))
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "video-and-bet-view-group" }
const _hoisted_28 = {
  class: "min-video-ref",
  ref: "refMinVideo"
}
const _hoisted_29 = {
  class: "video-area-group",
  ref: "refVideoContainer"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", { id: "player1" }, null, -1))
const _hoisted_31 = {
  key: 0,
  class: "video-loader"
}
const _hoisted_32 = { class: "type-game-id" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "13",
  viewBox: "0 0 12 13"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Polygon_8",
    "data-name": "Polygon 8",
    d: "M5.621,1.623a1,1,0,0,1,1.759,0l4.821,8.9A1,1,0,0,1,11.321,12H1.679A1,1,0,0,1,.8,10.524Z",
    transform: "translate(12) rotate(90)",
    fill: "#fff"
  })
], -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "value-btns" }
const _hoisted_36 = { class: "value-btns" }
const _hoisted_37 = { class: "value-btns" }
const _hoisted_38 = { class: "value-btns" }
const _hoisted_39 = { class: "value-btns" }
const _hoisted_40 = { class: "value-btns" }
const _hoisted_41 = {
  key: 4,
  class: "btn-s"
}
const _hoisted_42 = { class: "value-btns" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "13",
  viewBox: "0 0 12 13"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Polygon_8",
    "data-name": "Polygon 8",
    d: "M5.621,1.623a1,1,0,0,1,1.759,0l4.821,8.9A1,1,0,0,1,11.321,12H1.679A1,1,0,0,1,.8,10.524Z",
    transform: "translate(12) rotate(90)",
    fill: "#fff"
  })
], -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 3,
  class: "is-reserved"
}
const _hoisted_46 = { class: "bet-view-group-others" }
const _hoisted_47 = { class: "betting-button-control-group" }
const _hoisted_48 = { class: "road-summary-group" }
const _hoisted_49 = { class: "road-summary" }
const _hoisted_50 = ["data-label"]
const _hoisted_51 = ["data-label"]
const _hoisted_52 = ["data-label"]
const _hoisted_53 = ["data-label"]
const _hoisted_54 = ["data-label"]
const _hoisted_55 = { class: "limit-info" }
const _hoisted_56 = { class: "limit-info-title" }
const _hoisted_57 = { class: "limit-row" }
const _hoisted_58 = { class: "limit-item" }
const _hoisted_59 = { class: "limit-label" }
const _hoisted_60 = { class: "limit-value" }
const _hoisted_61 = { class: "limit-item" }
const _hoisted_62 = { class: "limit-label" }
const _hoisted_63 = { class: "limit-value" }
const _hoisted_64 = {
  key: 0,
  class: "limit-item"
}
const _hoisted_65 = { class: "limit-label" }
const _hoisted_66 = { class: "limit-value" }
const _hoisted_67 = {
  key: 1,
  class: "limit-item"
}
const _hoisted_68 = { class: "limit-label" }
const _hoisted_69 = { class: "limit-value" }
const _hoisted_70 = {
  key: 2,
  class: "limit-item"
}
const _hoisted_71 = { class: "limit-label" }
const _hoisted_72 = { class: "limit-value" }
const _hoisted_73 = {
  key: 3,
  class: "limit-item"
}
const _hoisted_74 = { class: "limit-label" }
const _hoisted_75 = { class: "limit-value" }
const _hoisted_76 = {
  key: 4,
  class: "limit-item"
}
const _hoisted_77 = { class: "limit-label" }
const _hoisted_78 = { class: "limit-value" }
const _hoisted_79 = {
  key: 5,
  class: "limit-item"
}
const _hoisted_80 = { class: "limit-label" }
const _hoisted_81 = { class: "limit-value" }
const _hoisted_82 = { class: "other-content" }
const _hoisted_83 = { class: "pre-group" }
const _hoisted_84 = {
  key: 0,
  class: "is-at-this-table"
}
const _hoisted_85 = { class: "m-other-content" }
const _hoisted_86 = { class: "m-mapheader" }
const _hoisted_87 = { class: "m-table-name-limit" }
const _hoisted_88 = { class: "m-map-summary" }
const _hoisted_89 = ["data-label"]
const _hoisted_90 = ["data-label"]
const _hoisted_91 = ["data-label"]
const _hoisted_92 = ["data-label"]
const _hoisted_93 = ["data-label"]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-h-fill" }, null, -1))
const _hoisted_95 = { class: "m-road-map-wrap" }
const _hoisted_96 = {
  key: 0,
  class: "is-at-this-table"
}
const _hoisted_97 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_user_l = _resolveComponent("i-user-l")!
  const _component_i_balance = _resolveComponent("i-balance")!
  const _component_icon_4sq = _resolveComponent("icon-4sq")!
  const _component_i_reload_g = _resolveComponent("i-reload-g")!
  const _component_i_card = _resolveComponent("i-card")!
  const _component_i_diamond = _resolveComponent("i-diamond")!
  const _component_i_balance_g = _resolveComponent("i-balance-g")!
  const _component_icon_pause_g = _resolveComponent("icon-pause-g")!
  const _component_icon_open_card_g = _resolveComponent("icon-open-card-g")!
  const _component_i_home = _resolveComponent("i-home")!
  const _component_i_full = _resolveComponent("i-full")!
  const _component_i_normal = _resolveComponent("i-normal")!
  const _component_i_arrow_h = _resolveComponent("i-arrow-h")!
  const _component_icon_return = _resolveComponent("icon-return")!
  const _component_icon_menu = _resolveComponent("icon-menu")!
  const _component_icon_video = _resolveComponent("icon-video")!
  const _component_icon_audio = _resolveComponent("icon-audio")!
  const _component_ctrl_bet_box_group = _resolveComponent("ctrl-bet-box-group")!
  const _component_ctrl_chips = _resolveComponent("ctrl-chips")!
  const _component_cancel_bet_button = _resolveComponent("cancel-bet-button")!
  const _component_repeat_bet_button = _resolveComponent("repeat-bet-button")!
  const _component_confirm_bet_button = _resolveComponent("confirm-bet-button")!
  const _component_road_map = _resolveComponent("road-map")!
  const _component_d_prediction = _resolveComponent("d-prediction")!
  const _component_card_preview_result = _resolveComponent("card-preview-result")!
  const _component_card_game_result = _resolveComponent("card-game-result")!
  const _component_m_prediction = _resolveComponent("m-prediction")!
  const _component_m_card_result = _resolveComponent("m-card-result")!
  const _component_marquee_text = _resolveComponent("marquee-text")!
  const _component_switch_table = _resolveComponent("switch-table")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.tableName), 1),
      (_ctx.gameTable && _ctx.gameTable.status === 4)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["timer-count-down", _ctx.timerColor])
          }, null, 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["timer-count-down", _ctx.timerColor])
          }, _toDisplayString(_ctx.currentCount >= 0 ? _ctx.currentCount : _ctx.t('game.settling')), 3)),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('game.shoeround')) + ":" + _toDisplayString(_ctx.shoeRound), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_i_user_l, { class: "icon user-l" }),
        _createTextVNode(" " + _toDisplayString(_ctx.user), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_i_balance, { class: "icon balance" }),
        _createTextVNode(" " + _toDisplayString(_ctx.coin), 1)
      ]),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "btn-s-h",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toMultibeting && _ctx.toMultibeting(...args)))
          }, [
            _createVNode(_component_icon_4sq, { class: "icon-btns-h" }),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t('loby.multiple')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showTableControls)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.userCommandType === 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "btn-s",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.callOperatStatus(1)), ["prevent"]))
                }, [
                  _createVNode(_component_i_reload_g, { class: "icon-btns" }),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t('game.changeshoe')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "btn-s",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callFlyBet && _ctx.callFlyBet(...args)), ["prevent"]))
            }, [
              _createVNode(_component_i_card, { class: "icon-btns" }),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('game.freegame')), 1)
            ]),
            (_ctx.tableCanReserved)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "btn-s",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callReservedOrCancellReserved && _ctx.callReservedOrCancellReserved(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_i_diamond, { class: "icon-btns" }),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.vipButtontext), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "btn-s",
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showTipBox && _ctx.showTipBox(...args)), ["prevent"]))
            }, [
              _createVNode(_component_i_balance_g, { class: "icon-btns" }),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('game.tip')), 1)
            ]),
            (_ctx.userCommandType === 2 && _ctx.isYoureReserved)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "btn-s",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callPauseRequest && _ctx.callPauseRequest(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_icon_pause_g, { class: "icon-btns" }),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.t('game.pause')), 1)
                ]))
              : _createCommentVNode("", true),
            (
                    (_ctx.isYoureReserved &&
                        _ctx.enableOpenPokerOP &&
                        _ctx.enableOpenPoker) ||
                    (_ctx.userCommandType === 1 &&
                        _ctx.enableOpenPokerOP &&
                        _ctx.enableOpenPoker)
                )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "btn-s",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callOpenPokeRequest && _ctx.callOpenPokeRequest(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_icon_open_card_g, { class: "icon-btns" }),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('game.open')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.userCommandType === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", {
                    class: "value-btns",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callGunnerFunc && _ctx.callGunnerFunc(...args)), ["prevent"]))
                  }, _toDisplayString(_ctx.callGunnerText), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.gameType === 'G002')
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: "btn-s",
            onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchPlayMode && _ctx.switchPlayMode(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.t('dialogs.gameplay.switchplaymode')), 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_17,
      _createVNode(_component_i_home, {
        class: "icon-home",
        onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'loby' })), ["prevent"]))
      }),
      (_ctx.fullScreenAvailable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            (!_ctx.isfullScreen)
              ? (_openBlock(), _createBlock(_component_i_full, {
                  key: 0,
                  class: "icon full",
                  onClick: _withModifiers(_ctx.requestFullScreen, ["prevent"])
                }, null, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_i_normal, {
                  key: 1,
                  class: "icon normal",
                  onClick: _withModifiers(_ctx.requestFullScreen, ["prevent"])
                }, null, 8, ["onClick"]))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "drop-down-setting",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showSettingDialog && _ctx.showSettingDialog(...args)))
      }, [
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t('game.menu')), 1),
        _createVNode(_component_i_arrow_h, {
          class: "icon-arrow",
          color: '#854b97'
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", {
        class: "m-return",
        onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'loby' })), ["prevent"]))
      }, [
        _createVNode(_component_icon_return)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_i_user_l, { class: "icon user-l" }),
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.user), 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_i_balance, { class: "icon balance" }),
        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.coin), 1)
      ]),
      _hoisted_25,
      (_ctx.gameTable && _ctx.gameTable.status === 4)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["m-timer", _ctx.timerColor])
          }, null, 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["m-timer", _ctx.timerColor])
          }, _toDisplayString(_ctx.currentCount >= 0 ? _ctx.currentCount : _ctx.t('game.settling')), 3)),
      _createElementVNode("div", {
        class: "m-menu",
        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.showSettingDialog && _ctx.showSettingDialog(...args)))
      }, [
        _createVNode(_component_icon_menu)
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("canvas", {
              id: "player2",
              class: _normalizeClass({ 'scale-video': _ctx.isScaleVideo })
            }, null, 2),
            (_ctx.isLoadingVideo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.commandTypeAndGameId), 1),
            (_ctx.gameType === 'G002' && (_ctx.rebateType !== 1 && _ctx.rebateType !== 3) && _ctx.enableFreeBaccarat)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["btn-toggle-game-mode", { disabled: !_ctx.allowToggleGameMode }])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: !_ctx.isFreeBaccarat }),
                    onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.tooggleGameMode(false)), ["prevent"]))
                  }, _toDisplayString(_ctx.t('game.baccarat')), 3),
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: _ctx.isFreeBaccarat }),
                    onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.tooggleGameMode(true)), ["prevent"]))
                  }, _toDisplayString(_ctx.t('game.commissionfreebaccarat')), 3)
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "switch-table",
              onClick: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hideSwitchTable && _ctx.hideSwitchTable(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.t('game.switchtable')), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["m-media-control", { active: !_ctx.showMediaControl }])
            }, [
              _createElementVNode("div", {
                class: "ico-video",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onToggleVideo && _ctx.onToggleVideo(...args)))
              }, [
                _createVNode(_component_icon_video, { "is-on": _ctx.deskVideoOn }, null, 8, ["is-on"])
              ]),
              _createElementVNode("div", {
                class: "ico-audio",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.toggleSoundEffect && _ctx.toggleSoundEffect(...args)))
              }, [
                _createVNode(_component_icon_audio, { "is-on": _ctx.soundIsOn }, null, 8, ["is-on"])
              ]),
              _createElementVNode("div", {
                class: "ico-play",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showMediaControl = !_ctx.showMediaControl))
              }, _hoisted_34)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["media-control-group", { disabled: _ctx.showMediaControl }])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["icon-video", { on: _ctx.deskVideoOn }]),
                onClick: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onToggleVideo && _ctx.onToggleVideo(...args)), ["prevent"]))
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["icon-sound", { on: _ctx.soundIsOn }]),
                onClick: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSoundEffect && _ctx.toggleSoundEffect(...args)), ["prevent"]))
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["icon-zoom", { on: _ctx.isScaleVideo }]),
                onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.isScaleVideo = !_ctx.isScaleVideo), ["prevent"]))
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["icon-full", { on: _ctx.isFullVideo }]),
                onClick: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleFullVideo && _ctx.toggleFullVideo(...args)), ["prevent"]))
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["icon-arrow-toggle", { on: _ctx.showMediaControl }]),
                onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (
                                _ctx.showMediaControl = !_ctx.showMediaControl
                                ), ["prevent"]))
              }, null, 2)
            ], 2),
            (_ctx.showTableControls || _ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["m-user-control-btns", { active: _ctx.showMobileFunctionControls }])
                }, [
                  _createElementVNode("div", null, [
                    (_ctx.showTableControls)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.userCommandType === 1)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "btn-s",
                                onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.callOperatStatus(1)), ["prevent"]))
                              }, [
                                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.t('game.changeshoe')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: "btn-s",
                            onClick: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callFlyBet && _ctx.callFlyBet(...args)), ["prevent"]))
                          }, [
                            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.t('game.freegame')), 1)
                          ]),
                          (_ctx.tableCanReserved)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "btn-s",
                                onClick: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => (
                                        _ctx.callReservedOrCancellReserved
                                     && 
                                        _ctx.callReservedOrCancellReserved
                                    (...args)), ["prevent"]))
                              }, [
                                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.vipButtontext), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: "btn-s",
                            onClick: _cache[27] || (_cache[27] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showTipBox && _ctx.showTipBox(...args)), ["prevent"]))
                          }, [
                            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.t('game.tip')), 1)
                          ]),
                          (
                                        _ctx.userCommandType === 2 && _ctx.isYoureReserved
                                    )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "btn-s",
                                onClick: _cache[28] || (_cache[28] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callPauseRequest && _ctx.callPauseRequest(...args)), ["prevent"]))
                              }, [
                                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.t('game.pause')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (
                                        (_ctx.isYoureReserved &&
                                            _ctx.enableOpenPokerOP &&
                                            _ctx.enableOpenPoker) ||
                                        (_ctx.userCommandType === 1 &&
                                            _ctx.enableOpenPokerOP &&
                                            _ctx.enableOpenPoker)
                                    )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 3,
                                class: "btn-s",
                                onClick: _cache[29] || (_cache[29] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callOpenPokeRequest && _ctx.callOpenPokeRequest(...args)), ["prevent"]))
                              }, [
                                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.t('game.open')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.userCommandType === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _createElementVNode("div", {
                                  class: "value-btns",
                                  onClick: _cache[30] || (_cache[30] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callGunnerFunc && _ctx.callGunnerFunc(...args)), ["prevent"]))
                                }, _toDisplayString(_ctx.callGunnerText), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.gameType === 'G002')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "btn-s",
                          onClick: _cache[31] || (_cache[31] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchPlayMode && _ctx.switchPlayMode(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.t('dialogs.gameplay.switchplaymode')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: "m-btns-play",
                    onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (
                                _ctx.showMobileFunctionControls =
                                !_ctx.showMobileFunctionControls
                                ), ["prevent"]))
                  }, _hoisted_44)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.isReserved)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45))
              : _createCommentVNode("", true)
          ], 512)
        ], 512),
        _createElementVNode("div", _hoisted_46, [
          (_openBlock(), _createBlock(_component_ctrl_bet_box_group, {
            class: "bet-view-group",
            gameType: _ctx.gameType,
            mData: _ctx.gameTable,
            key: _ctx.betViewKey,
            ref: "refBetGroup",
            onOnUpdate: _ctx.onPlaceTempBetOrClear,
            onOnBetSuccess: _ctx.onBetSuccess,
            isFreeBaccarat: _ctx.isFreeBaccarat,
            onEnableRepeatBet: _cache[33] || (_cache[33] = ($event: any) => (_ctx.isRepeatBetClicked = false)),
            onOnBetmodeChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onBetModeChange($event)))
          }, null, 8, ["gameType", "mData", "onOnUpdate", "onOnBetSuccess", "isFreeBaccarat"])),
          (_ctx.showChipControls)
            ? (_openBlock(), _createBlock(_component_ctrl_chips, {
                key: 0,
                class: "chips-group"
              }))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "btn-join-table",
                onClick: _cache[35] || (_cache[35] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.joinTable && _ctx.joinTable(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.btnJoinTableLabel), 1)),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_cancel_bet_button, {
              text: _ctx.t('game.betting.cancelbet'),
              onClick: _ctx.cancelBet,
              class: _normalizeClass({ enabled: _ctx.hasUnConfirmedBet })
            }, null, 8, ["text", "onClick", "class"]),
            _createVNode(_component_repeat_bet_button, {
              text: _ctx.t('game.betting.repeatbet'),
              onClick: _ctx.repeatBet,
              class: _normalizeClass({ enabled: _ctx.canRepeatBet })
            }, null, 8, ["text", "onClick", "class"]),
            _createVNode(_component_confirm_bet_button, {
              text: _ctx.t('game.betting.confirmbet'),
              onClick: _ctx.confirmBet,
              class: _normalizeClass({ enabled: _ctx.hasUnConfirmedBet })
            }, null, 8, ["text", "onClick", "class"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", {
            class: "road-map-summary-item red",
            "data-color": "red",
            "data-label": _ctx.gameType === 'G002'
                        ? _ctx.t('roadmap.banker')
                        : _ctx.t('roadmap.dragon')
                        
          }, _toDisplayString(_ctx.redCount), 9, _hoisted_50),
          _createElementVNode("div", {
            class: "road-map-summary-item blue",
            "data-color": "blue",
            "data-label": _ctx.gameType === 'G002'
                        ? _ctx.t('roadmap.player')
                        : _ctx.t('roadmap.tiger')
                        
          }, _toDisplayString(_ctx.blueCount), 9, _hoisted_51),
          _createElementVNode("div", {
            class: "road-map-summary-item green",
            "data-color": "green",
            "data-label": _ctx.t('roadmap.tie')
          }, _toDisplayString(_ctx.greenCount), 9, _hoisted_52),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "road-map-summary-item red",
                "data-color": "red",
                "data-label": _ctx.t('roadmap.pair')
              }, _toDisplayString(_ctx.redPairCount), 9, _hoisted_53))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "road-map-summary-item blue",
                "data-color": "blue",
                "data-label": _ctx.t('roadmap.pair')
              }, _toDisplayString(_ctx.bluePairCount), 9, _hoisted_54))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.t('game.limit')), 1),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.gameType === 'G002'
                                    ? _ctx.t('game.g2limit')
                                    : _ctx.t('game.g1limit')), 1),
              _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.redBlueLimit), 1)
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.t('game.tielimit')), 1),
              _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.greenLimit), 1)
            ]),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                  _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.t('game.pairlimit')), 1),
                  _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.pairLimit), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.t('game.super6limit')), 1),
                  _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.superSixLimit), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.t('game.dragon7limit')), 1),
                  _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.dragonSevenLimit), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                  _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.t('game.bear8limit')), 1),
                  _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.bearEightLimit), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.t('game.bigtigerlimit')), 1),
                  _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.bigTigerLimit), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                  _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.t('game.smalltigerlimit')), 1),
                  _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.smallTigerLimit), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_82, [
      (_openBlock(), _createBlock(_component_road_map, {
        ref: "roadmapview2",
        class: "road-map",
        mapData: _ctx.mapData,
        key: _ctx.deskMapKey,
        enablePrediction: true,
        onRoadMapData: _ctx.onRoadMapDataParsed,
        onRoadResultPreview: _ctx.handleOnMapPreview,
        enableClicked: true,
        gameType: _ctx.gameType === 'G002' ? 1 : 2
      }, null, 8, ["mapData", "onRoadMapData", "onRoadResultPreview", "gameType"])),
      _createElementVNode("div", _hoisted_83, [
        _createVNode(_component_d_prediction, {
          class: "pre",
          color: 1,
          gameType: _ctx.gameType === 'G002' ? 1 : 2,
          mapdata: _ctx.nextRedRoadMapSummaryData,
          onClick: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (_ctx.predict(1)), ["prevent"]))
        }, null, 8, ["gameType", "mapdata"]),
        _createVNode(_component_d_prediction, {
          class: "pre",
          color: 2,
          gameType: _ctx.gameType === 'G002' ? 1 : 2,
          mapdata: _ctx.nextBlueRoadMapSummaryData,
          onClick: _cache[37] || (_cache[37] = _withModifiers(($event: any) => (_ctx.predict(2)), ["prevent"]))
        }, null, 8, ["gameType", "mapdata"])
      ]),
      _createVNode(_Transition, { name: "fadein-out" }, {
        default: _withCtx(() => [
          (_ctx.showResultPreview)
            ? (_openBlock(), _createBlock(_component_card_preview_result, {
                key: 0,
                class: "card-preview",
                onClose: _cache[38] || (_cache[38] = ($event: any) => (_ctx.showResultPreview = false))
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.gameTable && _ctx.gameTable.status === 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t('game.shuffling')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showCardDisplay)
        ? (_openBlock(), _createBlock(_component_card_game_result, {
            class: "game-result",
            gameType: _ctx.gameType === 'G002' ? 1 : 2,
            info: _ctx.cardResultData,
            key: _ctx.cardResultKey
          }, null, 8, ["gameType", "info"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_85, [
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("div", null, _toDisplayString(_ctx.tableName), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.redBlueLimit), 1)
        ]),
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", {
            class: "road-map-summary-item red",
            "data-color": "red",
            "data-label": _ctx.gameType === 'G002'
                        ? _ctx.t('roadmap.banker')
                        : _ctx.t('roadmap.dragon')
                        
          }, _toDisplayString(_ctx.redCount), 9, _hoisted_89),
          _createElementVNode("div", {
            class: "road-map-summary-item blue",
            "data-color": "blue",
            "data-label": _ctx.gameType === 'G002'
                        ? _ctx.t('roadmap.player')
                        : _ctx.t('roadmap.tiger')
                        
          }, _toDisplayString(_ctx.blueCount), 9, _hoisted_90),
          _createElementVNode("div", {
            class: "road-map-summary-item green",
            "data-color": "green",
            "data-label": _ctx.t('roadmap.tie')
          }, _toDisplayString(_ctx.greenCount), 9, _hoisted_91),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "road-map-summary-item red",
                "data-color": "red",
                "data-label": _ctx.t('roadmap.pair')
              }, _toDisplayString(_ctx.redPairCount), 9, _hoisted_92))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "road-map-summary-item blue",
                "data-color": "blue",
                "data-label": _ctx.t('roadmap.pair')
              }, _toDisplayString(_ctx.bluePairCount), 9, _hoisted_93))
            : _createCommentVNode("", true)
        ]),
        _hoisted_94,
        _createVNode(_component_m_prediction, {
          class: "m-prediction blue",
          color: 'blue',
          gameType: _ctx.gameType === 'G002' ? 1 : 2,
          mapdata: _ctx.nextBlueRoadMapSummaryData,
          onClick: _cache[39] || (_cache[39] = _withModifiers(($event: any) => (_ctx.predict(2)), ["prevent"]))
        }, null, 8, ["gameType", "mapdata"]),
        _createVNode(_component_m_prediction, {
          class: "m-prediction red",
          color: 'red',
          gameType: _ctx.gameType === 'G002' ? 1 : 2,
          mapdata: _ctx.nextRedRoadMapSummaryData,
          onClick: _cache[40] || (_cache[40] = _withModifiers(($event: any) => (_ctx.predict(1)), ["prevent"]))
        }, null, 8, ["gameType", "mapdata"])
      ]),
      _createElementVNode("div", _hoisted_95, [
        (_openBlock(), _createBlock(_component_road_map, {
          ref: "roadmapview1",
          class: "road-map",
          "bead-row-count": 8,
          mapData: _ctx.mapData,
          key: _ctx.deskMapKey,
          enablePrediction: true,
          onRoadMapData: _ctx.onRoadMapDataParsed,
          onRoadResultPreview: _ctx.handleOnMapPreview,
          enableClicked: true,
          gameType: _ctx.gameType === 'G002' ? 1 : 2
        }, null, 8, ["mapData", "onRoadMapData", "onRoadResultPreview", "gameType"])),
        (_ctx.gameTable && _ctx.gameTable.status === 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t('game.shuffling')), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showCardDisplay)
        ? (_openBlock(), _createBlock(_component_m_card_result, {
            class: "m-card-result",
            gameType: _ctx.gameType === 'G002' ? 1 : 2,
            info: _ctx.cardResultData,
            key: `m-r-${_ctx.cardResultKey}`
          }, null, 8, ["gameType", "info"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_97, [
      (_openBlock(), _createBlock(_component_marquee_text, {
        class: "notice",
        key: _ctx.deskNoticeKey
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.deskNotice), 1)
        ]),
        _: 1
      }))
    ]),
    _createElementVNode("div", {
      ref: "refFullVideo",
      class: _normalizeClass(["max-video-full", { active: _ctx.isFullVideo }])
    }, null, 2),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withCtx(() => [
        (_ctx.showSwitchDesk)
          ? _withDirectives((_openBlock(), _createBlock(_component_switch_table, {
              key: 0,
              class: "switch-table",
              onEnterTable: _ctx.onSwitchTable,
              onClose: _cache[41] || (_cache[41] = ($event: any) => (_ctx.showSwitchDesk = false))
            }, null, 8, ["onEnterTable"])), [
              [_directive_click_outside, _ctx.hideSwitchTable]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}